import React from "react";
import "./HeroBanner.css";
import bannerImg from "../assets/Services/Promoters.png";

export default function HeroBanner() {
  return (
    <section
      className="cm-hero-section"
      style={{ backgroundImage: `url(${bannerImg})` }}
    >
      <div className="cm-hero-overlay">
        {/* LEFT CONTENT */}
        <div className="cm-hero-content">
          <span className="cm-hero-subtitle">CM GROUP</span>

          <h1 className="cm-hero-title-1">
            600 Acres: The Foundation for
Pollachi's Next Landmark.  
          </h1>

          {/* <div className="cm-hero-buttons">
            <button className="cm-hero-btn-primary">👍 Discover more</button>

            <button className="cm-hero-btn-secondary">👁 View services</button>
          </div> */}
        </div>

      </div>
    </section>
  );
}
